module.exports = __webpack_public_path__ + "img/cnu_gallery12.a8df3122.jpg";